export const clearObjectEmptyValues = (obj) => {
  for (const param in obj) {
    if (obj[param] === null) {
      delete obj[param];
    }
  }
};
